import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export function CardActionBar({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={cn(
        "sticky bottom-2 z-10 flex flex-wrap gap-2 rounded-xl border border-border/60 bg-card/92 p-2 shadow-sm backdrop-blur md:static md:border-0 md:bg-transparent md:p-0 md:shadow-none",
        className,
      )}
    >
      {children}
    </div>
  )
}
